// extracted by mini-css-extract-plugin
export default {"contentContainer":"Services_contentContainer__uuyxy","textContainer":"Services_textContainer__q2jsb"};